import React from "react";
import SearchBox from "./SearchBox";
import AddMemo from "./AddMemo";
import UserInfo from "./UserInfo";
import { AutoCatProvider } from "../contexts/AutoCatContext";

const HeaderNav = ({ uid, email, firstName, lastName, logout }) => {
  return (
    <div className='bg-white flex items-center px-5 shadow-sm w-full h-full'>
      <SearchBox />
      <AutoCatProvider>
        <AddMemo />
      </AutoCatProvider>
      <UserInfo
        uid={uid}
        email={email}
        firstName={firstName}
        lastName={lastName}
        logout={logout}
      />
    </div>
  );
};

export default HeaderNav;
